module.exports = __webpack_public_path__ + "img/contact_header.2582b8ac.webp";